import { useEffect, useState } from "react";
import axios from "axios";
import { StatusFieldDocument } from "../types/Types";

export const useDocumentStatusFields = (code: string) => {
  const [statusFields, setStatusFields] = useState<StatusFieldDocument[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!code) {
      setStatusFields([]);
      setLoading(false);
      return;
    }

    const source = axios.CancelToken.source();
    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token") ?? "";
        const res = await axios.get<StatusFieldDocument[]>(
          `${process.env.REACT_APP_API_URL ?? ""}/api/documentsType/status/${code}`,
          { headers: { "x-auth-token": token }, cancelToken: source.token }
        );
        if (!cancelled) setStatusFields(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        if (!axios.isCancel(err) && !cancelled) setStatusFields([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
      source.cancel("Canceled due to document status fields reload");
    };
  }, [code]);

  return { statusFields, loading };
};
